/* Compras de cada uno: «Mi lista» (lo que quiero traer, para quién y si ya lo compré) e «Ideas» por ciudad y persona.
   La lista es solo tuya: Yago y Daniel no ven la tuya ni tú la de ellos. */
import { useState } from 'react';
import { anadirCompra, borrarCompra, marcarCompra, misCompras, useApuntes } from '../datos/apuntes.ts';
import { IDEAS, NOMBRE_CIUDAD, NOMBRE_PARA, type Ciudad, type Para } from '../datos/ideas.ts';

const PARA = ['Yo', 'Familia', 'Amigos', 'Pareja'];

export function MiLista() {
  useApuntes();
  const [que, setQue] = useState(''), [para, setPara] = useState('Yo');
  const lista = misCompras();
  const faltan = lista.filter(c => !c.hecho).length;
  const anadir = () => { if (!que.trim()) return; anadirCompra({ que: que.trim(), para }); setQue(''); };
  return (
    <>
      <p className="texto"><b>{faltan}</b> por comprar de {lista.length}. Es solo tuya.</p>
      <div className="mi-lista__nuevo">
        <input className="concepto" type="text" value={que} maxLength={80} placeholder="Qué quieres traer…" aria-label="Qué quieres traer"
          onChange={e => setQue(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); anadir(); } }} />
        <div className="filtros" role="group" aria-label="Para quién">
          {PARA.map(x => <button key={x} type="button" aria-pressed={para === x} onClick={() => setPara(x)}>{x === 'Yo' ? 'Para mí' : x}</button>)}
        </div>
        <button type="button" className="accion" disabled={!que.trim()} onClick={anadir}>＋ Añadir a mi lista</button>
      </div>
      {lista.length === 0 && <p className="texto">Aún no has apuntado nada. Mira las ideas y toca «＋ A mi lista», o escribe lo que quieras.</p>}
      <ul className="mi-lista">
        {lista.map(c => (
          <li key={c.id} className={c.hecho ? 'is-hecha' : ''}>
            <label>
              <input type="checkbox" checked={c.hecho} onChange={e => marcarCompra(c.id, c, e.target.checked)} />
              <span className="mi-lista__texto"><b>{c.que}</b><small>{c.para === 'Yo' ? 'para mí' : `para ${c.para}`}{c.donde ? ` · ${c.donde}` : ''}</small></span>
            </label>
            <button type="button" className="mi-lista__borrar" aria-label={`Quitar «${c.que}»`} onClick={() => borrarCompra(c.id)}>✕</button>
          </li>
        ))}
      </ul>
    </>
  );
}

export function IdeasDeCompra() {
  const [ciudad, setCiudad] = useState<Ciudad>('todas'), [para, setPara] = useState<Para | 'todos'>('todos');
  useApuntes();
  const enLista = new Set(misCompras().map(c => c.idea).filter(Boolean));
  const ideas = IDEAS.filter(x => (ciudad === 'todas' || x.ciudad.includes(ciudad) || x.ciudad.includes('todas')) && (para === 'todos' || x.para.includes(para)));
  return (
    <>
      <p className="texto" style={{ fontSize: '.85rem' }}>Ideas por encima, con precios orientativos. Toca «＋ A mi lista» para guardarla.</p>
      <div className="filtros" role="group" aria-label="Ciudad">
        {(Object.keys(NOMBRE_CIUDAD) as Ciudad[]).map(c => <button key={c} type="button" aria-pressed={ciudad === c} onClick={() => setCiudad(c)}>{NOMBRE_CIUDAD[c]}</button>)}
      </div>
      <div className="filtros" role="group" aria-label="Para quién">
        <button type="button" aria-pressed={para === 'todos'} onClick={() => setPara('todos')}>Para todos</button>
        {(Object.keys(NOMBRE_PARA) as Para[]).map(x => <button key={x} type="button" aria-pressed={para === x} onClick={() => setPara(x)}>{NOMBRE_PARA[x]}</button>)}
      </div>
      <ul className="ideas">
        {ideas.map(x => (
          <li key={x.id}>
            <p className="ideas__que"><b>{x.que}</b> <span>{x.precio}</span></p>
            <p className="ideas__donde">{x.donde}</p>
            <p className="ideas__nota">{x.nota}</p>
            <button type="button" className="accion" disabled={enLista.has(x.id)}
              onClick={() => anadirCompra({ que: x.que, para: x.para[0] === 'yo' ? 'Yo' : x.para[0] === 'familia' ? 'Familia' : 'Amigos', donde: x.donde.split(',')[0], idea: x.id })}>
              {enLista.has(x.id) ? '✓ En mi lista' : '＋ A mi lista'}
            </button>
          </li>
        ))}
      </ul>
      {ideas.length === 0 && <p className="texto">Nada con esos filtros.</p>}
    </>
  );
}
